import Checkbox from "@mui/material/Checkbox";
import { MRT_ColumnDef } from "material-react-table";
import moment from "moment/moment";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { APP_GMT_DATE_FORMAT } from "@/lib/constants";
import { SysCfgRegularDto } from "@/shared/api";
import { AnyObj } from "@/types/common-types";

export const useReporterChatTableColumns = () => {
  const { t } = useTranslation();

  return useMemo<MRT_ColumnDef<SysCfgRegularDto>[]>(() => {
    return [
      {
        header: t("enabled"),
        filterFn: "contains",
        accessorKey: "enabled",
        enableEditing: false,
        accessorFn: (row) => row.enabled ?? "-",
        Cell: ({ row }) => <Checkbox checked={row.original.enabled} disabled />,
        grow: true,
      },
      {
        header: t("name"),
        accessorKey: "name",
        filterFn: "contains",
        grow: true,
      },
      {
        header: t("room"),
        accessorKey: "data.room",
        accessorFn: ({ data }) => (data as AnyObj)?.room?.join(", ") ?? "-",
        filterFn: "contains",
        grow: true,
      },
      {
        header: t("technology"),
        accessorFn: ({ data }) => (data as AnyObj)?.technology?.join(", ") ?? "-",
        accessorKey: "data.technology",
        filterFn: "contains",
      },
      {
        header: t("gameType"),
        accessorFn: ({ data }) => (data as AnyObj)?.game_type?.join(", ") ?? "-",
        filterFn: "contains",
      },
      {
        header: t("aid"),
        accessorFn: ({ data }) => (data as AnyObj)?.aid?.join(", ") ?? "-",
        filterFn: "contains",
      },
      {
        header: t("cid"),
        accessorFn: ({ data }) => (data as AnyObj)?.cid?.join(", ") ?? "-",
        filterFn: "contains",
      },
      {
        header: t("botId"),
        accessorKey: "data.bot_id",
        filterFn: "contains",
      },
      {
        header: t("rules"),
        accessorFn: ({ data }) => (data as AnyObj)?.rules?.join(", ") ?? "-",
        accessorKey: "data.rules",
        filterFn: "contains",
      },
      {
        header: t("createdAt"),
        accessorKey: "created_at",
        accessorFn: (row) => (row.created_at ? new Date(row.created_at) : 0),
        Cell: ({
          row: {
            original: { created_at },
          },
        }) => (created_at ? moment(created_at).utc(false).format(APP_GMT_DATE_FORMAT) : "-"),
      },
      {
        header: t("updatedAt"),
        accessorKey: "updated_at",
        accessorFn: (row) => (row.updated_at ? new Date(row.updated_at) : 0),
        Cell: ({
          row: {
            original: { created_at },
          },
        }) => (created_at ? moment(created_at).utc(false).format(APP_GMT_DATE_FORMAT) : "-"),
      },
    ];
  }, [t]);
};
